<div class="component-center-view">
  <div *ngIf="allData">
    <app-main-filter
      [reportCount]="allReportsCounter || 0"
      (emitClickedFilter)="fetchMainFilter($event)"
      (emitReverseSort)="fetchMainFilterReverse($event)"></app-main-filter>

    <app-login-user [loginURL]="loginURL"
                    *ngIf="!favoriteReportsData && showSortView && !showAllData"></app-login-user>

    <app-favorite-reports *ngIf="favoriteReportsData && !showAllData" [allData]="favoriteReportsData.data"
                          [showFavoriteComponent]="showFavoriteView"
                          [userNiceName]="favoriteReportsData?.username?.at(0)"></app-favorite-reports>

    <app-single-report-small *ngIf="showAllData" [showFavoriteIconCompletely]="showFavoriteIcon" [allData]="allData"
                             [filterType]="activeSortFilter" [powerbiData]="powerBiData" [charts]="allCharts"
                             [reverseArray]="activeReverseArray"></app-single-report-small>
  </div>
  <div *ngIf="showPostComponent">
    <app-post-view [postData]="singlePostData"></app-post-view>
  </div>
  <app-loader></app-loader>
</div>
